import { Component, inject, OnInit } from '@angular/core';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';
import { DynamicPageElement, DynamicPagesService } from '../../../services/dynamic-pages/dynamic-pages.service';
import { DynamicPageEditorHelperService } from '../../../services/dynamic-page-editor-helper/dynamic-page-editor-helper.service';
import { GungNotificationService } from 'gung-common';

@Component({
  selector: 'lib-dynamic-page-dc-container',
  standalone: false,
  templateUrl: './dynamic-page-dc-container.component.html',
  styleUrl: './dynamic-page-dc-container.component.scss'
})
export class DynamicPageDcContainerComponent extends DynamicPageDcBaseComponent implements OnInit {
  dynamicPagesService = inject(DynamicPagesService);
  dynamicPageEditorHelperService = inject(DynamicPageEditorHelperService);
  gungNotificationService = inject(GungNotificationService);

  elementId = 'container';

  fields = {
    maxWidth: 1200,
    tabletMaxWidth: 960,
    mobileMaxWidth: 540,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    backgroundColor: null,
    elements: []
  };

  override ngOnInit(): void {
    if (!this.element) {
      this.element = { id: this.elementId, fields: {} };
    }
    if (Object.keys(this.element.fields).length === 0) {
      this.element.fields = {
        maxWidth: 1200,
        tabletMaxWidth: 960,
        mobileMaxWidth: 540,
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        backgroundColor: null,
        elements: []
      };
    }
    if (!Array.isArray(this.element.fields.elements)) {
      this.element.fields.elements = [];
    }
  }

  get currentSelected() {
    return this.dynamicPageEditorHelperService.getSelectedElement();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const draggedElement = this.dynamicPageEditorHelperService.draggedElement;
    if (draggedElement) {
      if (draggedElement.id === 'grid' || draggedElement.id === 'container') {
        this.gungNotificationService.notify('ERROR', 'Cannot add grid or container inside a container', 'error');
        return;
      }
      const component: DynamicPageElement = { id: draggedElement.id, fields: {} };
      this.element.fields.elements.push(component);
    }
  }

  onElementClick(comp: any, event: MouseEvent) {
    if (this.edit) {
      event.stopPropagation();
      this.dynamicPageEditorHelperService.setSelectedElement(this.element);
      this.dynamicPageEditorHelperService.editElementInGrid = comp;
    }
  }

  moveUp(index: number) {
    const elements = this.element.fields.elements;
    if (index > 0) {
      [elements[index - 1], elements[index]] = [elements[index], elements[index - 1]];
    }
  }

  moveDown(index: number) {
    const elements = this.element.fields.elements;
    if (index < elements.length - 1) {
      [elements[index + 1], elements[index]] = [elements[index], elements[index + 1]];
    }
  }

  deleteElement(index: number) {
    this.element.fields.elements.splice(index, 1);
  }

  copy(index: number) {
    this.dynamicPageEditorHelperService.copy = structuredClone(this.element.fields.elements[index]);
  }

  paste() {
    const copied = this.dynamicPageEditorHelperService.copy;
    if (copied?.id === 'grid' || copied?.id === 'container') {
      this.gungNotificationService.notify('ERROR', 'Cannot paste grid or container inside a container', 'error');
      return;
    }
    this.element.fields.elements = [...this.element.fields.elements, copied];
    this.dynamicPageEditorHelperService.copy = null;
  }
}
